<template>
  <div class="swiper-container swiper-news-home-small">
    <div class="swiper-wrapper">
      <div @click="goAdUrl(item.jump_url)" class="swiper-slide cursor" v-for="(item, index) in newsSwipers" :key="index">
        <img :src="item.image_url ? item.image_url : require('./default.png')" />
      </div>
    </div>
    <div class="swiper-pagination"></div>
  </div>
</template>

<script>
import Swiper, { Autoplay, Pagination } from "swiper";
Swiper.use([Autoplay, Pagination]);
import { post } from "@/util/http";

export default {
  name: "test",
  components: {},
  data() {
    return {
      newsSwipers: [],
    };
  },
  watch: {
    newsSwipers() {
      this.$nextTick(() => {
        new Swiper(".swiper-news-home-small", {
          loop: true,
          autoplay: {
            delay: 7000, //自动切换的时间间隔，单位ms
            stopOnLastSlide: false, //如果设置为true，当切换到最后一个slide时停止自动切换。
            disableOnInteraction: false, //用户操作swiper之后，是否禁止autoplay。
            reverseDirection: false, //开启反向自动轮播。
            waitForTransition: false, //等待过渡完毕。自动切换会在slide过渡完毕后才开始计时。
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
        });
      });
    },
  },
  async mounted() {
    // const {
    //   data: { data },
    // } = await post({
    //   url: "/api/ads/getHomeScrollAd",
    // });
    // this.newsSwipers = data || [];
  },
  methods: {
    goAdUrl(url) {
      window.open(url, "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
.swiper-news-home-small {
  border-radius: 0.1rem 0.1rem 0 0;
}

img {
  width: 100%;
  height: 1.4rem;
  object-fit: cover;
}
.cursor {
  cursor: pointer;
}
</style>
